<template>
    <article class="news-internal">
        <a :href="post.link" class="news-internal-anchor">
            <div>
                <img :data-src="post.thumbnail.url" class="swiper-lazy" width="550px" height="550px">
            </div>
            <div class="news-internal-info">
                <h2 v-html="post.title"></h2>
                <div class="news-internal-date">{{post.date}} <tags :categories="post.categories || []" size="small"></tags></div>
            </div>
        </a>
    </article>
</template>

<script>
	import Tags from "../article/tags.vue"
	export default {
		components: {
		    Tags
        },
		props: [
			"post"
		]
	}
</script>

<style lang="scss" scoped>
    @import "~foundation-sites/scss/foundation";
    article.news-internal {
        overflow: hidden;
        border-radius: .5rem;
    }
    .news-internal {
        margin: 1rem;
        box-shadow: 1px 1px 6px 3px rgba(0, 0, 0, .2);
    }

    .news-internal img {
        width: 550px;
        height: auto;
        display: block;
    }

    .news-internal h2 {
        align-self: baseline;
        margin: 0;
        padding: .5rem 1rem;
        color: inherit;
        font-weight: normal;
        @include breakpoint(medium) {
            line-height: 1.8rem;
            font-size: 1.4rem;
        }
        @include breakpoint(large) {
            line-height: 2rem;
            font-size: 1.5rem;
        }
    }

    .news-internal-date {
        margin: 0;
        padding: .5rem 1rem;
        font-size: .9rem;
        color: inherit;
        @include breakpoint(medium) {
            font-size: 1rem;
        }
        @include breakpoint(large) {
            font-size: 1.1rem;
        }
    }
    .news-internal-anchor {
        height: 100%;
        display: block;
        position: relative;
    }
    .news-internal-info {
        display: flex;
        align-items: flex-end;
        color: white;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        flex-wrap: wrap;
    }
    .news-internal-info > * {
        flex: 100% 0 0;
        background: rgba(0, 0, 0, 0.4);
    }
    .tag {
        padding: 2.5px 5px;
        margin-left: 5px;
        background-color: #547f3a;
        border-radius: 5px;
        border: 1px solid white;
    }
</style>


// WEBPACK FOOTER //
// news-internal.vue?71e9a7e8